<!-- --------------------------- sidebar  --------------------------->
<div class="content">
    <div class="notice" *ngIf="notifications && notifications.length>0">
        <div class="title-custom">
            <div class="corner"></div>
            <a  style="color: #fff">
                Thông Báo</a>
        </div>
        <div *ngIf="notifications" class="list-notice">
            <div *ngFor="let notification of notifications" class="item">
                <img *ngIf="notification?.isNew" src="assets/img/newicon_vi.gif" alt="{{notification?.title}}" />
                <a class="custom-hover" (click)="onTitleClick(notification)">{{notification?.title | slice:0:50}}...
                </a>
                <span>({{notification?.postdate | date:'dd/MM/yyyy'}})</span>
            </div>
        </div>
    </div>
    <div class="img-activity">
        <div class="title-custom">
            <div class="corner"></div>
            <a  style="color: #fff">
                Hình Ảnh Hoạt Động</a>
        </div>
        <div id="img-activity" class="carousel slide border" data-ride="carousel">
            <div *ngIf="albums" class="carousel-inner">
                <div *ngFor="let album of albums" class="{{album?.style}}">
                    <img (click)="onImageClick(album)" class="d-block w-100" src="https://hce.edu.vn{{album.pathimage}}" alt="{{album?.title}}" />
                    <div class="carousel-caption">
                        <p>{{album?.title | slice:0:30}}</p>
                    </div>
                </div>
            </div>
        </div>
        <a class="carousel-control-prev" href="#img-activity" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#img-activity" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
    <!--liên kết website -->
    <div class="link-web">
        <div class="title">
            <div class="icon-title">
                <img class="img-responsive" alt="Liên kết Website" class="img-responsive" src="assets/img/world.png" />
                <span class="table-cell">Liên kết Website</span>
            </div>
        </div>
        <div class="select-link">
            <div class="form-group">
                <select (change)="onLinkChange($event)" class="form-control" style="width:99%;" id="link-website">
                    <option value="">-- Chọn liên kết website --</option>
                    <option *ngFor="let item of listConnectiveWebsite" [value]="item?.link">{{item?.title}}</option>
                </select>
            </div>
        </div>
    </div>
    <!-- video -->
    <div class="video-embed">
        <iframe width="100%" height="210" src="https://www.youtube.com/embed/6g49R1UnNps" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <!-- truy cập -->
    <div class="column-chart" *ngIf="visits">
        <div class="title">
            <img src="assets/img/column-chart.png" alt="Thống Kê Truy Cập" />
            <span>Thống Kê Truy Cập</span>
        </div>
        <div class="data-access">
            
            <div class="data">
                <span>Tổng lượt truy cập: </span> <span>{{visits}}</span>
            </div>
        </div>
    </div>
    <!-- end truy cập -->
</div>
<!-- --------------------------- end sidebar  --------------------------->
